import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  arrayPush,
  arrayRemoveAll,
  Field,
  FieldArray,
  formValueSelector,
  reduxForm,
} from "redux-form";
import { Popup, Icon, Message } from "semantic-ui-react";
import {
  // fetchAgreements,
  // fetchBanks,
  updateCompany,
  saveEnrolmentCompanyData,
  setLoading,
} from "../../../../../actions";
import { Images } from "../../../../../constants";
import {
  FULL__STEP_FIVE__COMPANY,
  FULL__STEP_SIX__COMPANY,
} from "../../../../../sagas/navigation/stepTypes";
import { email, required } from "../../../../../utilities/validationRules";
import Button from "../../../../shared/button";
import Checkbox from "../../../../shared/checkbox";
import Divider from "../../../../shared/divider";
import { ConnectedInput } from "../../../../shared/input/ConnectedInput";
import { ConnectedOccupationInput } from "../../../../shared/input/ConnectedOccupationInput";
import { FormattedInput } from "../../../../shared/input/FormattedInput";
import { RadioGroup } from "../../../../shared/radio";
import { Stepper } from "../../../../shared/stepper";
// import { steps } from "./sampleConstants";
import {
  BankPaymentMethods,
  steps,
} from "../../../../shared/company-enrolment/sampleData";
import {
  addToMetaDataPayloadString,
  resetPayload,
} from "../../../../shared/company-enrolment/company-helpers";
import GradientButton from "../../../../auth/login/components/GradientButton";
import GoogleSuggest from "../../../../shared/googlePlaces";
import DateInput from "../../../../shared/customDateInput";
import moment from "moment";

export class BankAccount extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.bottomRef = React.createRef();
    this.state = {
      submission: false,
      terms: false,
      // "The Authorized Signer is different from the Corporate Contact." When
      // unchecked, the corporate contact is the signer (the role is stacked onto
      // them at Review). Default to checked only if separate signers already exist.
      authorizedSignerDifferentFromCorporateContact:
        this.props.company?.person?.metaInformation
          ?.authorizedSignerDifferentFromCorporateContact ?? false,
      institutionNumber: "",
      bankPaymentMethod: this.props.bankPaymentMethod,
      payloadString: this.props.payloadString,
      bankNumber: this.props.bankNumber,
      bankBranchNumber: this.props.bankBranchNumber,
      accountNumber: this.props.accountNumber,
      authorizedSigners: this.props.authorizedSigners,
      payloadString: this.props.payloadString,
      companyEnrolment: this.props.companyEnrolment ?? {},
      prepaySectionNumber: 13,
      enrolledByEmail: this.props.enrolledByEmail,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);

    setTimeout(() => {
      const { selectedCompanyGuid, email } = this.props.companyEnrolment ?? {};
      this.setState({
        selectedCompanyGuid,
        email,
      });

      // Only seed an empty signer row when the signer is marked different from
      // the corporate contact (the checkbox). Otherwise we'd create a phantom
      // empty signer that stays hidden behind the gate but gets submitted.
      if (
        this.state.authorizedSignerDifferentFromCorporateContact &&
        (!this.props.authorizedSigners ||
          (this.props.authorizedSigners &&
            this.props.authorizedSigners?.length === 0))
      ) {
        this.props.dispatch(
          arrayPush("CompanyBankAccount", "authorizedSigners", {})
        );
      }
    });
  }
  switchAccountType = (id) => {
    this.setState({ accountTypeId: id });
  };

  toggleSubmission = () => {
    this.setState({ submission: !this.state.submission });
  };
  toggleTerms = () => {
    this.setState({ terms: !this.state.terms });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  setFormattedAddress = (name, address) => {
    const { formatted_address } = address;
    this.props.change(name, formatted_address);
  };

  setFormattedDate = (name, date) => {
    this.props.change(name, date);
  };

  toggleGeneric = (name) => {
    this.setState({ [name]: !this.state[name] });
  };

  chosePaymentType = (value) => {
    this.setState({ bankPaymentMethod: value }, () => {
      // if (
      //   this.state.bankPaymentMethod === "pad" &&
      //   this.props.authorizedSigners.length < 1
      // ) {
      //   this.props.dispatch(
      //     arrayRemoveAll("CompanyBankAccount", "authorizedSigners")
      //   );
      //   this.props.dispatch(
      //     arrayPush("CompanyBankAccount", "authorizedSigners", {})
      //   );
      // }
      // if (
      //   this.state.bankPaymentMethod !== "pad" &&
      //   this.props.authorizedSigners.length > 0
      // ) {
      //   this.props.dispatch(
      //     arrayRemoveAll("CompanyBankAccount", "authorizedSigners")
      //   );
      // }
    });
  };

  scrollToBottom = () => {
    if (this.bottomRef.current) {
      this.bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Toggle "the signer is different from the corporate contact". When turned on,
  // a blank signer row is added so the detail fields appear; when turned off, the
  // corporate contact is the signer and every signer row is cleared.
  toggleAuthorizedSignerDifferent = () => {
    const next = !this.state.authorizedSignerDifferentFromCorporateContact;
    this.setState({ authorizedSignerDifferentFromCorporateContact: next });
    if (next) {
      // Signer is different - make sure there's a row to fill in so the detail
      // fields appear immediately (not just the "+ Add Authorized Signer" link).
      if (
        !this.props.authorizedSigners ||
        this.props.authorizedSigners.length === 0
      ) {
        this.props.dispatch(
          arrayPush("CompanyBankAccount", "authorizedSigners", {})
        );
      }
    } else {
      // Signer is the corporate contact, so clear every signer row. The detail
      // cards collapse, leaving only the always-present "+ Add Authorized Signer"
      // link for adding any other signers.
      this.props.dispatch(
        arrayRemoveAll("CompanyBankAccount", "authorizedSigners")
      );
    }
  };

  // Real-time check: does this Authorized Signer's email duplicate another
  // role's? Corporate Contact email lives in companyEnrolment.email; Plan Admin in
  // companyData.person.metaInformation.planAdminContact. Returns the clashing
  // role label or null. Mirrors the Review-step "Email Conflict" rule so the
  // user is alerted on entry, not only at Proceed.
  getSignerEmailConflict = (index) => {
    const norm = (e) => (e == null ? "" : String(e)).trim().toLowerCase();
    const signers = this.props.authorizedSigners || [];
    const target = norm(signers[index] && signers[index].email);
    if (!target) return null;
    // Corporate Contact email = the typed value saved at company.person.email
    // (what the Review-step check uses). companyEnrolment.email is only the invite
    // email and can differ if the contact email was edited - fall back to it.
    const corporate = norm(
      this.props.company?.person?.email ||
        (this.props.companyEnrolment && this.props.companyEnrolment.email)
    );
    if (corporate && target === corporate) return "Corporate Contact";
    let planAdmin = "";
    try {
      let pa = this.props.company?.person?.metaInformation?.planAdminContact;
      if (pa) {
        if (typeof pa === "string") pa = JSON.parse(pa);
        // planAdminContact stores the email under `planAdminEmail` (see
        // Contacts.js), not `email` - read the right key so the clash is caught
        // inline here, not only at the Review-step "Email Conflict".
        planAdmin = norm(pa && (pa.planAdminEmail || pa.email));
      }
    } catch (e) {}
    if (planAdmin && target === planAdmin) return "Plan Administrator";
    for (let j = 0; j < signers.length; j++) {
      if (j !== index && signers[j] && norm(signers[j].email) === target) {
        return `Authorized Signer ${j + 1}`;
      }
    }
    return null;
  };

  render() {
    const { styles, handleChange, updateView } = this.props;
    const { bankPaymentMethod } = this.state;
    return (
      <>
        <div
          className={styles.msgContainer}
          style={{
            width: "600px",
            fontFamily: "Montserrat",
            textAlign: "center",
          }}
        >
          Reminder: Click "
          <a
            onClick={this.scrollToBottom}
            style={{
              cursor: "pointer",
            }}
          >
            Save and Continue
          </a>
          " button to keep your progress!
        </div>
        <div className={styles.contentContainerX}>
          <div className={styles.description}>
            <Stepper
              steps={steps}
              activeStep={4}
              context={"company-full"}
              businessOperatedName={this.props.businessOperatedName}
            />
          </div>
          <div className={styles.section}>
            <div className={styles.subHeaderLabels}>
              Section{" "}
              {this.state.programPaymentType !== "postpayment" ? 14 : 11}:
              Invoicing Info
            </div>
            <div className={styles.standaloneLabel}>
              How do you plan on paying your invoices?
              <span style={{ color: "#d0021b" }}> *</span>
            </div>
            <div className={styles.sectionContent}>
              <RadioGroup
                items={BankPaymentMethods}
                value={this.state.bankPaymentMethod}
                name="opt-group"
                onUpdate={(value) => this.chosePaymentType(value)}
              />
              {bankPaymentMethod === "pad" && (
                <div className={styles.msgContainer}>
                  Funds will be automatically withdrawn from the company's
                  account and transferred to us via EFT (Electronic Funds
                  Transfer). Please note that there will be a 10-day hold on the
                  funds to clear with no additional fees.
                </div>
              )}
              {bankPaymentMethod === "wire" && (
                <div className={styles.msgContainer}>
                  Aya will issue an invoice, and the company must manually
                  transfer the funds to pay it.
                </div>
              )}
            </div>
          </div>
          {bankPaymentMethod === "pad" && (
            <div className={styles.section}>
              <div className={styles.superSubHeader}>Pre-Authorized Debit</div>
              <div className={styles.sectionContent}>
                <Popup
                  content={
                    <React.Fragment>
                      <React.Fragment>
                        <img
                          className={styles.tooltipImage}
                          src={Images.institutionNumber}
                        />
                      </React.Fragment>
                      {
                        "you can find this 3 digit number on the bottom of a cheque or on your online banking"
                      }
                    </React.Fragment>
                  }
                  trigger={
                    <div className={styles.standaloneLabel}>
                      Financial Institution Number{" "}
                      <span style={{ color: "#d0021b" }}>*</span>{" "}
                      <img src={Images.question} className={styles.tooltip} />{" "}
                    </div>
                  }
                />
                <Field
                  component={ConnectedInput}
                  label=""
                  name="bankNumber"
                  type="text"
                  max={3}
                  extrastyle="semi-small"
                  placeholder="---"
                />

                <Popup
                  content={
                    <React.Fragment>
                      <React.Fragment>
                        <img
                          className={styles.tooltipImage}
                          src={Images.branchNumber}
                        />
                      </React.Fragment>
                      {
                        "you can find this 5 digit number on the bottom of a cheque or on your online banking"
                      }
                    </React.Fragment>
                  }
                  trigger={
                    <div className={styles.standaloneLabel}>
                      Branch Transit Number{" "}
                      <span style={{ color: "#d0021b" }}>*</span>{" "}
                      <img src={Images.question} className={styles.tooltip} />{" "}
                    </div>
                  }
                />
                <Field
                  component={ConnectedInput}
                  label=""
                  name="bankBranchNumber"
                  type="text"
                  max={5}
                  extrastyle="semi-small"
                  placeholder="-----"
                />

                <Popup
                  content={
                    <React.Fragment>
                      <React.Fragment>
                        <img
                          className={styles.tooltipImage}
                          src={Images.accountNumber}
                        />
                      </React.Fragment>
                      {
                        "you can find this number on the bottom of a cheque or on your online banking"
                      }
                    </React.Fragment>
                  }
                  trigger={
                    <div className={styles.standaloneLabel}>
                      Account Number{" "}
                      <span style={{ color: "#d0021b" }}>*</span>{" "}
                      <img src={Images.question} className={styles.tooltip} />{" "}
                    </div>
                  }
                />
                <Field
                  component={ConnectedInput}
                  label=""
                  name="accountNumber"
                  type="text"
                  extrastyle="large"
                  placeholder="xxxxxxxxxx"
                />
              </div>
            </div>
          )}
          {/* {this.props.programPaymentType !== "postpayment" && ( */}
          <React.Fragment>
            <div className={styles.section}>
              <div className={styles.section}>
                <div className={styles.subHeaderLabels}>
                  Section 15: Authorized Signer
                </div>
                <div className={styles.msgContainer}>
                  An authorized signer is legally empowered to manage the
                  company's Aya account, including signing and conducting
                  transactions. Aya, as a registered Money Services Business
                  (MSB) under FINTRAC regulations, requires authorized signers
                  to provide two forms of ID to enroll a business and activate
                  an account.
                </div>
              </div>
              <div className={styles.inputContainer}>
                <Checkbox
                  checked={
                    this.state.authorizedSignerDifferentFromCorporateContact
                  }
                  onClick={() => this.toggleAuthorizedSignerDifferent()}
                  darkBox={"darkBox"}
                  label={
                    "Check this box if the Authorized Signer is different from the Corporate Contact"
                  }
                />
              </div>
              <React.Fragment>
                <div className={styles.description}>
                  {this.state.authorizedSignerDifferentFromCorporateContact
                    ? "Please provide the details of the authorized signer(s) for this account."
                    : "Are there any other authorized signers for this account?"}
                </div>
                <div
                  className={styles.description}
                  style={{ marginBottom: "20px" }}
                >
                  You can add up to 3 authorized signers. Each will be required
                  to undergo ID Verification.
                </div>
                <FieldArray
                  name="authorizedSigners"
                  component={this.renderAuthorizedSigners}
                  styles={styles}
                  mystate={this.state}
                />
              </React.Fragment>
            </div>
          </React.Fragment>
          {/* )} */}

          <div className={styles.buttonAreaContainer}>
            <GradientButton
              handleClick={() => {
                // e.preventDefault();
                this.updateBankAccount(FULL__STEP_SIX__COMPANY);
              }}
              style={{
                marginTop: "20px",
              }}
              label="Save And Continue"
              testid="saveAndContinue"
              width="100%"
            ></GradientButton>

            {/* Bottom element to scroll to */}
            <div ref={this.bottomRef}></div>
          </div>
        </div>
      </>
    );
  }

  renderAuthorizedSigners = ({ styles, handleChange, fields, mystate }) => (
    <div>
      {fields.map((authorizedSigner, index) => (
        <div
          key={index}
          className={`${styles.sectionContent} ${styles.directorWrapper}`}
        >
          <div className={`${styles.blueContainer} ${styles.checkboxActive}`}>
            <div className={styles.sectionTitle}>
              Authorized Signer {index + 1}
            </div>
            <div className={styles.inputContainer}>
              <Field
                component={ConnectedInput}
                label="First Name"
                name={`${authorizedSigner}.firstName`}
                type="text"
                validate={[required]}
                required={true}
                placeholder="Enter First Name"
                extrastyle="medium"
              />
              <div style={{ paddingRight: 20, marginRight: 10 }} />
              <Field
                component={ConnectedInput}
                label="Last Name"
                name={`${authorizedSigner}.lastName`}
                type="text"
                validate={[required]}
                required={true}
                extrastyle="medium"
                placeholder="Enter Last Name"
              />
            </div>
            <div>
              <Field
                component={ConnectedInput}
                label="Email"
                name={`${authorizedSigner}.email`}
                type="email"
                validate={[required, email]}
                required={true}
                placeholder="Enter Email"
              />
              {(() => {
                const conflictRole = this.getSignerEmailConflict(index);
                return conflictRole ? (
                  <span
                    style={{
                      color: "red",
                      fontSize: 12,
                      fontWeight: "bold",
                      paddingLeft: 3,
                      display: "block",
                      marginTop: 3,
                    }}
                  >
                    {`This email can't be the same as the ${conflictRole} email.`}
                  </span>
                ) : null;
              })()}
              <div
                className={styles.msgContainer}
                color="green"
                style={{
                  marginBottom: 10,
                }}
              >
                <Icon name="info circle" />
                <span>
                  The Authorized Signer Email Address must be unique and should
                  be used only as the Authorized Signer.
                </span>
              </div>
            </div>
            <br />
            <Field
              component={FormattedInput}
              label="Mobile Number"
              name={`${authorizedSigner}.mobileNumber`}
              type="tel"
              labelDetail="optional, if providing Work Number"
              myFormat="+1 (###) ###-####"
              placeholder="Enter Mobile Number"
            />
            <div className={styles.multiInputContainer}>
              <Field
                component={FormattedInput}
                label="Work Number"
                name={`${authorizedSigner}.workNumber`}
                type="tel"
                extrastyle="large"
                labelDetail="optional, if providing Mobile Number"
                myFormat="+1 (###) ###-####"
                placeholder="Enter Work Number"
              />
              <Field
                component={ConnectedInput}
                label="Extension"
                name={`${authorizedSigner}.workNumberExt`}
                type="text"
                extrastyle="tiny"
                placeholder="0"
              />
            </div>
            <Field
              component={ConnectedOccupationInput}
              label="Occupation and Title"
              name={`${authorizedSigner}.occupation`}
              validate={[required]}
              required={true}
              placeholder="Enter Occupation and Title"
            />

            <div>
              {this.props.authorizedSigners &&
              this.props.authorizedSigners?.length > 0 &&
              this.props.authorizedSigners[index] &&
              this.props.authorizedSigners[index].address &&
              !this.state[
                `${authorizedSigner}.authorizedSignerAddressEditMode`
              ] ? (
                <React.Fragment>
                  <br />
                  <Field
                    component={ConnectedInput}
                    label="Physical Address"
                    name={`${authorizedSigner}.address`}
                    type="text"
                    // validate={[required]}
                    required={true}
                    disabled={true}
                    fixed={true}
                  />
                  <Button
                    name="Edit Address"
                    style="primary"
                    onClick={() =>
                      this.toggleGeneric(
                        `${authorizedSigner}.authorizedSignerAddressEditMode`
                      )
                    }
                  />
                  <br />
                </React.Fragment>
              ) : (
                <>
                  <span className={styles.fieldLabel}>Physical Address <span style={{ color: "#d0021b" }}>*</span></span>
                  <GoogleSuggest
                    name={`${authorizedSigner}.address`}
                    setAddress={(name, address) =>
                      this.setFormattedAddress(name, address)
                    }
                    labelDetail="Enter Address"
                    value={this.state[`${authorizedSigner}.address`]}
                    placeholder="Start typing to search for address..."
                    label="Physical Address"
                  />
                </>
              )}
            </div>
            <DateInput
              label="Date of Birth"
              name={`${authorizedSigner}.dateOfBirth`}
              type="text"
              extrastyle="medium"
              selected={(() => {
                let authorizedSignerDateOfBirth =
                  this.props.authorizedSigners &&
                  this.props.authorizedSigners[index] &&
                  this.props.authorizedSigners?.length > 0
                    ? moment
                        .utc(this.props.authorizedSigners[index].dateOfBirth)
                        .toDate()
                    : null;
                return authorizedSignerDateOfBirth;
              })()}
              handleDateChange={(date, name) =>
                this.setFormattedDate(name, date)
              }
              // validate={[required]}
              error={
                this.props.authorizedSigners &&
                this.props.authorizedSigners?.length > 0 &&
                this.props.authorizedSigners[index] &&
                moment
                  .utc(this.props.authorizedSigners[index].dateOfBirth)
                  .isAfter(Date.now(), "day")
                  ? "Date cannot be greater than today"
                  : this.props.authorizedSigners &&
                    this.props.authorizedSigners?.length > 0 &&
                    this.props.authorizedSigners[index] &&
                    moment
                      .utc()
                      .diff(
                        this.props.authorizedSigners[index].dateOfBirth,
                        "years",
                        true
                      ) < 18
                  ? "Must be over 18 years of age"
                  : ""
              }
            />
            <div>
              {_.size(fields) > 0 && (
                <div className={styles.removeAdministratorWrapper}>
                  <a
                    href={"#"}
                    onClick={(e) => {
                      e.preventDefault();
                      fields.remove(index);
                    }}
                    className={styles.removeAdministrator}
                  >
                    - Remove Authorized Signer
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {_.size(fields) < 3 && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            fields.push();
          }}
          className={styles.addAdministrator}
        >
          + Add Authorized Signer
        </a>
      )}
    </div>
  );

  updateBankAccount = async (nextStep) => {
    const {
      bankName,
      bankBranchNumber,
      bankNumber,
      accountNumber,
      authorizedSigners,
    } = this.props;
    // Don't let a duplicate-email signer save & continue - the inline error
    // (same rule as the Review-step "Email Conflict") tells them which to fix.
    if (
      (authorizedSigners || []).some((_, i) => this.getSignerEmailConflict(i))
    ) {
      return;
    }
    const { selectedBankName, institutionNumber, bankPaymentMethod } =
      this.state;

    let payloadData = this.props.company;

    //modify contacts
    let { contacts = [] } = payloadData;

    //Remove authorizedSigners
    if (
      contacts &&
      typeof contacts !== null &&
      typeof contacts.forEach === "function"
    ) {
      var i = contacts.length;
      while (i--) {
        if (contacts[i].userRole.name === "planSponsorAuthorizedSigner") {
          contacts.splice(i, 1);
        }
      }
    }

    const params = {
      method: "put",
      path: `invites/${payloadData.inviteGuid}`,
      sendNotification: false,
      data: {
        ...payloadData,
        dirty: true,
        inviteState: {
          dirty: true,
          step: nextStep,
          status: "active",
        },
        person: {
          // ...payloadData.person,
          dirty: false,
          countryCode: "CA",
          languageCode: "en",
          programDefinedVariables: {},
          metaInformation: {
            ...payloadData.person?.metaInformation,
            authorizedSignerDifferentFromCorporateContact:
              this.state.authorizedSignerDifferentFromCorporateContact,
          },
        },
        contacts: contacts || [],
        business: {
          ...payloadData.business,
          dirty: true,
          businessPreferredLanguage: "en",
          country: "CA",
          mailingCountry: "CA",
          institutionType: "planSponsor",
          defaultPaymentMethod: bankPaymentMethod,
          metaInformation: {
            ...payloadData.business.metaInformation,
            newPlanAdminGuid: this.props.newPlanAdmin
              ? this.props.newPlanAdmin.inviteGuid
              : "",
            dirty: true,
          },
        },
        bankAccountDetails: {
          dirty: true,
          bankName:
            institutionNumber === "0" ? bankName : selectedBankName || "",
          bankBranchNumber: bankBranchNumber,
          bankNumber: bankNumber,
          bankAccountNumber: accountNumber,
          bankAccountType: "business",
        },
        accessToken: "",
      },
    };
    if (authorizedSigners && authorizedSigners.length > 0) {
      for (const authorizedSigner of authorizedSigners) {
        if (authorizedSigner && authorizedSigner.email) {
          let item = {
            firstName: authorizedSigner.firstName,
            lastName: authorizedSigner.lastName,
            email: authorizedSigner.email
              ? authorizedSigner.email.toLowerCase()
              : undefined,
            userRole: {
              label: "PlanSponsor Company Authorized Signer",
              name: "planSponsorAuthorizedSigner",
            },
            countryCode: "CA",
            languageCode: "en",
            mobileNumber: authorizedSigner.mobileNumber,
            workNumber: authorizedSigner.workNumber,
            workNumberExt: authorizedSigner.workNumberExt,
            dirty: true,
            metaInformation: {
              dirty: true,
              address: authorizedSigner.address,
              occupation: authorizedSigner.occupation,
              dateOfBirth: authorizedSigner?.dateOfBirth ?? "",
            },
          };
          params.data.contacts.push(item);
        }
      }
    }

    //Payload string
    const modifiedPayloadString = addToMetaDataPayloadString(
      this.state.payloadString,
      params.data
    );
    let newParams = resetPayload(params);
    newParams.data.business.metaInformation["payloadString"] =
      modifiedPayloadString;

    try {
      // let response = this.props.updateCompany(newParams);
      let response = await this.props.saveEnrolmentCompanyData({
        companyData: modifiedPayloadString,
        enrolledByEmail: this.state.enrolledByEmail,
        guid: this.state.selectedCompanyGuid,
      });
    } catch (ex) {
      this.props.setLoading({
        error: true,
        errorMessage:
          "We couldn't save your information. Please try again, or contact support@ayacare.com if the problem continues.",
      });
      console.error("Failed to save enrolment data:", ex);
    }
  };
}

const validate = (formValues) => {
  const {
    bankName,
    accountNumber,
    bankBranchNumber,
    bankNumber,
    bankPaymentMethod,
    authorizedSigners = [],
  } = formValues;
  const errors = {};

  if (bankBranchNumber) {
    const trimmedValue = bankBranchNumber.replace(/\s/g, "");

    // Check for numeric only
    if (!/^\d+$/.test(trimmedValue)) {
      errors.bankBranchNumber = "Must contain only numbers";
    }
  } else if (!bankBranchNumber && bankPaymentMethod === "pad") {
    errors.bankBranchNumber = "Branch Transit Number is required";
  }

  if (accountNumber) {
    const trimmedValue = accountNumber.replace(/\s/g, "");

    // Check for numeric only
    if (!/^\d+$/.test(trimmedValue)) {
      errors.accountNumber = "Must contain only numbers";
    }
  } else if (!accountNumber && bankPaymentMethod === "pad") {
    errors.accountNumber = "Account Number is required";
  }

  if (bankNumber) {
    const trimmedValue = bankNumber.replace(/\s/g, "");

    // Check for numeric only
    if (!/^\d+$/.test(trimmedValue)) {
      errors.bankNumber = "Must contain only numbers";
    }
  } else if (!bankNumber && bankPaymentMethod === "pad") {
    errors.bankNumber = "Bank Number is required";
  }

  if (authorizedSigners && authorizedSigners.length > 0) {
    const authorizedSignersErrors = [];

    authorizedSigners.forEach((signer, index) => {
      const signerErrors = {};

      // Check if neither mobile nor work number is provided
      if (!signer?.mobileNumber && !signer?.workNumber) {
        signerErrors.mobileNumber =
          "Either Mobile Number or Work Number is required";
        signerErrors.workNumber =
          "Either Mobile Number or Work Number is required";
      }

      // Only add to array if there are errors for this signer
      if (Object.keys(signerErrors).length > 0) {
        authorizedSignersErrors[index] = signerErrors;
      }
    });

    // Only add to errors if there are any signer errors
    if (authorizedSignersErrors.length > 0) {
      errors.authorizedSigners = authorizedSignersErrors;
    }
  }

  return errors;
};

const WrappedBankAccount = reduxForm({
  form: "CompanyBankAccount",
  validate,
  enableReinitialize: true,
})(BankAccount);

const mapStateToProps = (state) => {
  const selector = formValueSelector("CompanyBankAccount");

  const { newPlanAdmin } = state.companyReducer;

  const data = state.companyReducer?.companyEnrolment?.companyData ?? {};
  let payloadString =
    JSON.stringify(state.companyReducer.companyEnrolment?.companyData) ?? "";
  const companyEnrolment = state.companyReducer.companyEnrolment ?? {};

  const enrolledByEmail = state.authReducer?.preAuthDetails?.email ?? "";

  const businessOperatedName =
    _.get(data, "business.businessOperatedName") ?? "";

  let bankPaymentMethod = _.get(data, "business.defaultPaymentMethod") ?? "";
  let bankNumber = _.get(data, "bankAccountDetails.bankNumber") ?? "";
  let bankBranchNumber =
    _.get(data, "bankAccountDetails.bankBranchNumber") ?? "";
  let accountNumber = _.get(data, "bankAccountDetails.bankAccountNumber") ?? "";
  let contacts = _.get(data, "contacts") ?? [];

  let authorizedSigners = [];
  if (contacts?.length > 0 && typeof contacts?.forEach === "function") {
    for (let item of contacts) {
      if (item.userRole.name === "planSponsorAuthorizedSigner") {
        // authorizedSigners.push(item);
        authorizedSigners.push({
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          mobileNumber: item.mobileNumber,
          workNumber: item.workNumber,
          workNumberExt: item.workNumberExt,
          occupation: item.metaInformation
            ? item.metaInformation.occupation
            : "",
          address: item.metaInformation ? item.metaInformation.address : "",
          dateOfBirth:
            item.metaInformation && item.metaInformation?.dateOfBirth
              ? moment(item.metaInformation?.dateOfBirth).toDate()
              : null,
        });
      }
    }
  }

  //get programDefinedVariables's
  //business pdv's
  let programDefinedVariables = {};
  if (
    _.get(data, "business.programDefinedVariables") &&
    typeof data.business.programDefinedVariables !== null &&
    typeof data.business.programDefinedVariables.forEach === "function"
  ) {
    data.business.programDefinedVariables.forEach((item) => {
      if (
        item.productVariableDefinition.variableName &&
        item.variableValue.length > 0
      ) {
        programDefinedVariables[item.productVariableDefinition.variableName] =
          item.variableValue;
      }
    });
  } else if (_.get(data, "business.programDefinedVariables")) {
    for (let item in data.business.programDefinedVariables) {
      if (
        _.get(
          data,
          `business.programDefinedVariables[${item}].productVariableDefinition.variableName`
        )
      ) {
        programDefinedVariables[
          data.business.programDefinedVariables[
            item
          ].productVariableDefinition.variableName
        ] =
          data.business.programDefinedVariables[
            item
          ].productVariableDefinition.variableValue;
      }
      programDefinedVariables[item] =
        data.business.programDefinedVariables[item];
    }
  }

  return {
    newPlanAdmin,
    bankName: selector(state, "bankName"),
    bankBranchNumber: selector(state, "bankBranchNumber"),
    bankNumber: selector(state, "bankNumber"),
    accountNumber: selector(state, "accountNumber"),
    authorizedSigners: selector(state, "authorizedSigners"),
    company: data,
    programPaymentType:
      _.get(
        data,
        "business.programDefinedVariables.contractTerm.programPaymentType"
      ) || _.get(programDefinedVariables, "programPaymentType"),
    bankPaymentMethod: bankPaymentMethod,
    payloadString: payloadString,
    businessOperatedName: selector(state, "businessOperatedName"),
    payloadString: payloadString,
    companyEnrolment: selector(state, "companyEnrolment"),
    enrolledByEmail: enrolledByEmail,

    initialValues: {
      bankPaymentMethod: bankPaymentMethod,
      payloadString: payloadString,
      bankNumber: bankNumber,
      bankBranchNumber: bankBranchNumber,
      accountNumber: accountNumber,
      authorizedSigners: authorizedSigners,
      businessOperatedName: businessOperatedName,
      payloadString: payloadString ?? "",
      companyEnrolment: companyEnrolment,
      enrolledByEmail: enrolledByEmail,
    },
  };
};

export default connect(mapStateToProps, {
  updateCompany,
  saveEnrolmentCompanyData,
  setLoading,
})(WrappedBankAccount);
